import { storeToRefs } from 'pinia';
import mainStore from '@/stores/main-store';

const useMainStore = () => {
    const { setAccessToken, setUsername, setPrivileges } = mainStore();
    const { username, accessToken, oid, hasWritePrivilege, privileges } = storeToRefs(mainStore());

    return {
        username,
        accessToken,
        privileges,
        oid,
        hasWritePrivilege,
        setAccessToken,
        setUsername,
        setPrivileges
    };
};

export default useMainStore;
